import ComponentName from '@Constant/componentName'
import {
  EDIT_TASK_MARK,
  TASK_DETAIL_MARK,
  CREATE_TASK_SUCCEED_MARK,
  ORDER_STATISTIC_NEW_MARK,
  TASK_STATISTIC_NEW_MARK,
  ORDER_MARK,
  COOPERATION_MODE,
  CREATE_TASK_FIRST,
  CREATE_TASK_SECOND,
  LIVE_ORDER_STATISTIC_MARK
} from '@Constant/behaviorTrack'

const home = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/market',
    children: [
      {
        component: () => import('../../views/market/task/place-task.vue'),
        path: 'task/place.task',
        name: ComponentName.task.placeTask,
        auth: '*',
        meta: {
          title: '任务下单',
          logAuto: {
            pv: true,
            duration: true,
            source: COOPERATION_MODE.PV
          }
        }
      },
      {
        component: () => import('../../views/market/Index.vue'),
        path: 'content',
        name: ComponentName.market.content,
        auth: '*',
        meta: {
          title: '内容定制',
          logAuto: {
            pv: true,
            duration: true,
            source: ORDER_MARK.PV
          }
        },
        props: {
          componentName: ComponentName.market.content
        },
        children: [
          {
            component: () => import('../../views/market/task/content-task/CreateOrder/index.vue'),
            path: 'task/create',
            name: ComponentName.task.create,
            auth: '*',
            meta: {
              title: '新建任务',
              logAuto: {
                pv: true,
                duration: true,
                source: CREATE_TASK_FIRST.PV
              }
            }
          },
          {
            component: () => import('../../views/market/task/content-task/CreateOrder/Edit.vue'),
            path: 'task/edit/:id',
            name: ComponentName.task.edit,
            props: true,
            auth: '*',
            meta: {
              title: '编辑任务',
              logAuto: {
                pv: true,
                duration: true,
                source: EDIT_TASK_MARK.PV
              }
            }
          },
          {
            component: () => import('../../views/market/task/content-task/Detail.vue'),
            path: 'task/detail/:id',
            name: ComponentName.task.detail,
            props: true,
            auth: '*',
            meta: {
              title: '任务详情',
              logAuto: {
                pv: true,
                duration: true,
                source: TASK_DETAIL_MARK.PV
              }
            },
            children: [
              {
                component: () => import('../../views/statistic-new/task/Index.vue'),
                path: 'statistic-new',
                name: ComponentName.task.statisticNew,
                props: true,
                auth: '*',
                meta: {
                  title: '投后数据',
                  logAuto: {
                    pv: true,
                    duration: true,
                    source: TASK_STATISTIC_NEW_MARK.PV,
                    reportQuery: ['id']
                  }
                }
              },
              {
                component: () => import('../../views/statistic-new/task/dynamic.vue'),
                path: 'dynamic-statistic',
                name: ComponentName.task.dynamicStatistic,
                props: true,
                auth: '*',
                meta: {
                  title: '投后数据',
                  logAuto: {
                    pv: true,
                    duration: true,
                    source: TASK_STATISTIC_NEW_MARK.PV,
                    reportQuery: ['id']
                  }
                }
              }
            ]
          },
          {
            component: () => import('../../views/upper/TaskSelectedUpper.vue'),
            path: 'selected/:task_id',
            name: ComponentName.upper.selectedUpper,
            props: true,
            meta: {
              title: '任务选中up主',
              logAuto: {
                pv: true,
                duration: true,
                source: CREATE_TASK_SECOND.PV
              }
            }
          },
          {
            component: () => import('../../views/market/task/content-task/SuccessRules.vue'),
            path: 'success/:id',
            name: ComponentName.task.successRules,
            props: true,
            meta: {
              title: '下单成功',
              logAuto: {
                pv: true,
                duration: true,
                source: CREATE_TASK_SUCCEED_MARK.PV
              }
            }
          },
          {
            component: () => import('../../views/market/task/content-task/recruit/Index.vue'), // 开发时用，记得改回去
            path: 'recruit',
            name: ComponentName.task.recruit,
            props: true,
            meta: {
              title: '新建招募任务'
            }
          },
          {
            component: () => import('../../views/market/task/content-task/recruit/TaskRules.vue'),
            path: 'recruit/rule',
            name: ComponentName.task.recruitRule,
            props: true,
            meta: {
              title: '招募任务规则'
            }
          },
          {
            component: () => import('../../views/market/order/detail/Index.vue'),
            path: 'order/detail/:id',
            name: ComponentName.order.detail,
            auth: '*',
            props: true,
            meta: {
              title: '订单详情'
            },
            children: [
              {
                component: () => import('../../views/statistic-new/order/Index.vue'),
                path: 'order/statistic-new',
                name: ComponentName.order.statisticNew,
                props: true,
                auth: '*',
                meta: {
                  title: '投后数据',
                  logAuto: {
                    pv: true,
                    duration: true,
                    source: ORDER_STATISTIC_NEW_MARK.PV,
                    reportQuery: ['id']
                  }
                }
              },
              {
                component: () => import('../../views/statistic-new/order/dynamic.vue'),
                path: 'dynamic-order/statistic-new',
                name: ComponentName.order.dynamicStatistic,
                props: true,
                auth: '*',
                meta: {
                  title: '投后数据',
                  logAuto: {
                    pv: true,
                    duration: true,
                    source: ORDER_STATISTIC_NEW_MARK.PV,
                    reportQuery: ['id']
                  }
                }
              },
              {
                component: () => import('../../views/statistic-new/order/liveOrder.vue'),
                path: 'live-order/statistic-new',
                name: ComponentName.order.liveStatistic,
                props: true,
                auth: '*',
                meta: {
                  title: '投后数据',
                  logAuto: {
                    pv: true,
                    duration: true,
                    source: LIVE_ORDER_STATISTIC_MARK.PV,
                    reportQuery: ['id']
                  }
                }
              },
              {
                component: () => import('../../views/market/order/common/SetPriceHistory.vue'),
                path: 'order/revise',
                name: ComponentName.order.revise,
                props: true,
                auth: '*',
                meta: {
                  title: '改价记录'
                }
              },
              {
                component: () => import('../../views/market/order/detail/CommentDetails.vue'),
                path: 'order/commentdetail/:orderId',
                name: ComponentName.order.commentdetail,
                props: true,
                auth: '*',
                meta: {
                  title: '评价详情'
                }
              },
              {
                component: () => import('../../views/videoAuthorize/Detail.vue'),
                path: 'videoAuthorize/:authId',
                name: ComponentName.order.videoAuthorize,
                props: true,
                auth: '*',
                meta: {
                  title: '视频授权详情'
                }
              },
              {
                component: () => import('../../views/market/common/dynamic-auth/DynamicAuthDetail.vue'),
                path: 'DynamicAuthDetail/:authId',
                name: ComponentName.order.DynamicAuthDetail,
                props: true,
                auth: '*',
                meta: {
                  title: '动态授权详情'
                }
              },
              {
                component: () => import('../../views/uniteOrder/update/Create.vue'),
                path: 'unitOrder/create',
                name: ComponentName.order.uniteOrderCreate,
                auth: '*',
                meta: {
                  title: '创建联合投稿'
                }
              },
              {
                component: () => import('../../views/uniteOrder/detail/Index.vue'),
                path: 'unitOrder/detail/:publishId',
                name: ComponentName.order.uniteOrderDetail,
                props: true,
                auth: '*',
                meta: {
                  title: '联合投稿详情'
                }
              },
              {
                component: () => import('../../views/uniteOrder/update/Edit.vue'),
                path: 'unitOrder/edit/:publishId',
                name: ComponentName.order.uniteOrderEdit,
                props: true,
                auth: '*',
                meta: {
                  title: '编辑联合投稿'
                }
              }
            ]
          }
        ]
      },
      {
        component: () => import('../../views/market/Index.vue'),
        path: 'effectdivide',
        name: ComponentName.market.effectDivide,
        auth: '*',
        meta: {
          title: '效果分成'
        },
        props: {
          componentName: ComponentName.market.effectDivide
        }
      },
      {
        component: () => import('../../views/market/task/task-recruit/recruitListIndex.vue'),
        path: 'taskrecruit',
        name: ComponentName.task.taskrecruit.index,
        auth: '*',
        meta: {
          title: '招募任务'
        },
        props: {
          componentName: ComponentName.task.taskrecruit.index
        }
      },
      {
        component: () => import('../../views/market/task/task-recruit/Index.vue'),
        path: 'taskrecruit/create',
        name: ComponentName.task.taskrecruit.create,
        auth: '*',
        meta: {
          title: '新建任务'
        }
      },
      {
        component: () => import('../../views/market/task/task-recruit/Index.vue'),
        path: 'taskrecruit/edit/:id',
        name: ComponentName.task.taskrecruit.edit,
        auth: '*',
        meta: {
          title: '编辑任务'
        }
      },
      {
        component: () => import('../../views/market/task/task-recruit/detail/index.vue'),
        path: 'market/detail/:id',
        name: ComponentName.task.taskrecruit.detail,
        auth: '*',
        meta: {
          title: '招募详情'
        },
        props: true
      },
      {
        component: () => import('../../views/market/task/effect-divide/list/detail.vue'),
        path: 'effectdivide/detail/:id',
        name: ComponentName.task.effectDivide.detail,
        auth: '*',
        meta: {
          title: '任务详情'
        },
        props: true
      },
      {
        component: () => import('../../views/market/task/effect-divide/list/mix-detail.vue'),
        path: 'effectdivide/mixDetail/:id',
        name: ComponentName.task.effectDivide.mixDetail,
        auth: '*',
        meta: {
          title: '任务详情'
        },
        props: true
      },
      {
        component: () => import('../../views/market/task/effect-divide/action/create.vue'),
        path: 'effectdivide/create',
        name: ComponentName.task.effectDivide.create,
        auth: '*',
        meta: {
          title: '新建任务'
        }
      },
      {
        component: () => import('../../views/market/task/effect-divide/action/edit.vue'),
        path: 'effectdivide/edit/:id',
        name: ComponentName.task.effectDivide.edit,
        auth: '*',
        props: true,
        meta: {
          title: '编辑任务'
        }
      }
    ]
  }
]

export default home
